import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onUpdated } from 'vue';
import { useField } from 'vee-validate';
import { scrollToTop } from '../../helpers/scrollToTop';


export default {
  __name: 'ExternalErrorHinter',
  props: {
    externalErrors: {
        type: Array,
        required: false,
    },
},
  setup(__props) {

const props = __props;



onUpdated(() => {
    props.externalErrors.forEach(({ key, hint }) => {
        const { setErrors } = useField(key);
        setErrors(hint);
        setTimeout(() => {
            scrollToTop();
        }, 100);
    });
});

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

}